import { z } from "zod";
export const VenusIdleQuerySchema = z.object({
    nova: z.enum(["true", "false"]).optional(),
    deepSpace: z.enum(["true", "false"]).optional(),
}).strict();
export const VenusIdleRoleSchema = z.object({
    allocated: z.boolean(),
    active: z.boolean(),
    observedAt: z.number().int().nonnegative(),
    idleExpiresAt: z.number().int().nonnegative().nullable(),
});
export const VenusIdleStatusSchema = z.object({
    parent: VenusIdleRoleSchema,
    explorer: VenusIdleRoleSchema.nullable(),
});
